import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import HomePageTwo from "./pages/HomePageTwo";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import HomePrinters from "./pages/HomePrinters";
import InkjetPrinters from "./pages/InkjetPrinters";
import OfficePrinters from "./pages/OfficePrinters";
import LaserPrinters from "./pages/LaserPrinters";
import InkToner from "./pages/InkToner";
import OrderConfirm from "./pages/OrderConfirm";
import WishlistPage from "./pages/WishlistPage";
import AboutUs from "./pages/AboutUs";
import PrivacyPage from "./pages/PrivacyPage";
import RefundPage from "./pages/RefundPage";
import ShippingPage from "./pages/ShippingPage";
import TermsPage from "./pages/TermsPage";
import CookiePage from "./pages/CookiePage";
import OrderTrack from "./pages/OrderTrack";
import ReturnTrack from "./pages/ReturnTrack";
import Account from "./pages/Account";
import { Toaster } from "react-hot-toast";

import CanonPrinter from "./pages/CanonPrinter";
import BrotherPrinter from "./pages/BrotherPrinter";
import EpsonPrinter from "./pages/EpsonPrinter";
import HpPrinter from "./pages/HpPrinter";
import Book from "./pages/Book";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Toaster position="top-center" reverseOrder={false} />

      <Routes>
        <Route exact path="/one" element={<HomePageOne />} />
        <Route exact path="/" element={<HomePageTwo />} />
        <Route exact path="/shop" element={<ShopPage />} />
        <Route exact path="/home-printers" element={<HomePrinters />} />
        <Route exact path="/inkjet-printers" element={<InkjetPrinters />} />
        <Route exact path="/office-printers" element={<OfficePrinters />} />
        <Route exact path="/laser-printers" element={<LaserPrinters />} />
        <Route exact path="/toner-papers" element={<InkToner />} />
        <Route exact path="/order-confirmed" element={<OrderConfirm />} />
        <Route exact path="/wishlist" element={<WishlistPage />} />
        <Route exact path="/about-us" element={<AboutUs />} />
        <Route exact path="/privacy-policy" element={<PrivacyPage />} />
        <Route exact path="/terms-and-conditions" element={<TermsPage />} />
        <Route exact path="/cookie-policy" element={<CookiePage />} />
        <Route exact path="/shipping-policy" element={<ShippingPage />} />
        <Route exact path="/refund-policy" element={<RefundPage />} />
        <Route exact path="/order-track" element={<OrderTrack />} />
        <Route exact path="/return-order" element={<ReturnTrack />} />
        <Route exact path="/my-account" element={<Account />} />

        <Route exact path="/canon-printers" element={<CanonPrinter />} />
        <Route exact path="/brother-printers" element={<BrotherPrinter />} />
        <Route exact path="/hp-printers" element={<HpPrinter />} />
        <Route exact path="/epson-printers" element={<EpsonPrinter />} />

        <Route
          exact
          path="/product-details"
          element={<ProductDetailsPageOne />}
        />
        <Route exact path="/product/:id" element={<ProductDetailsPageTwo />} />
        <Route exact path="/cart" element={<CartPage />} />
        <Route exact path="/checkout" element={<CheckoutPage />} />
        <Route exact path="/login" element={<LoginPage />} />
        <Route exact path="/register" element={<RegisterPage />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog-details" element={<BlogDetailsPage />} />
        <Route exact path="/contact-us" element={<ContactPage />} />
        <Route exact path="/book-an-appointment" element={<Book />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
